/* assets/mc2-lightbox.js — CL-0071: purpose-built product-image lightbox.
   Replaces Horizon's built-in zoom (templates/product.json media-gallery "zoom": false,
   which removes zoom-dialog.js, the <zoom-dialog> markup, and the grid zoom buttons).
   Behavior:
   - Click a PDP gallery image -> centered black window opens (built on demand).
   - Click the image inside -> toggle expand (natural size, pannable) / reduce (fit-contain).
   - Close via the X (top-right), clicking outside the window, or Escape.
   - On close the overlay is fully removed from the DOM (no lingering overlay/cursor).
   - Horizontal thumbnail strip below the primary image switches images.
   Supersedes assets/mc2-zoom.css (CL-0070). Do not reintroduce overrides on
   .dialog-zoomed-gallery* — that markup no longer renders. */
(function () {
  'use strict';
  if (window.__mc2Lightbox) return;
  window.__mc2Lightbox = true;

  var FR = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  var T = {
    dialog: FR ? "Visionneuse d'images" : 'Image viewer',
    close: FR ? 'Fermer' : 'Close',
    zoom: FR ? "Agrandir ou réduire l'image" : 'Expand or reduce image',
    thumb: FR ? "Afficher l'image" : 'Show image'
  };

  var state = null; // { overlay, box, stage, img, thumbs, items, index, lastFocus }

  function fullUrl(img) {
    return img.getAttribute('data-max-resolution') || img.currentSrc || img.src;
  }

  function thumbUrl(u) {
    if (!u) return u;
    if (/([?&])width=\d+/.test(u)) return u.replace(/([?&])width=\d+/, '$1width=180');
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=180';
  }

  function collectMedia(gallery) {
    var seen = {};
    var items = [];
    gallery.querySelectorAll('.product-media-container--image .product-media').forEach(function (pm) {
      var id = pm.getAttribute('data-media-id');
      var img = pm.querySelector('img.product-media__image');
      if (!id || !img || seen[id]) return;
      seen[id] = true;
      items.push({ id: id, full: fullUrl(img), alt: img.alt || '' });
    });
    return items;
  }

  function el(tag, className, attrs) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (attrs) Object.keys(attrs).forEach(function (k) { node.setAttribute(k, attrs[k]); });
    return node;
  }

  function open(gallery, mediaId, trigger) {
    if (state) close();
    var items = collectMedia(gallery);
    if (!items.length) return;
    var index = 0;
    for (var i = 0; i < items.length; i++) if (items[i].id === mediaId) { index = i; break; }

    var overlay = el('div', 'mc2-lightbox-overlay');
    var box = el('div', 'mc2-lightbox', { role: 'dialog', 'aria-modal': 'true', 'aria-label': T.dialog });
    var closeBtn = el('button', 'mc2-lightbox__close', { type: 'button', 'aria-label': T.close });
    closeBtn.innerHTML = '&#10005;';
    var stage = el('div', 'mc2-lightbox__stage');
    var img = el('img', 'mc2-lightbox__image', { alt: '' });
    var zoomHint = el('span', 'visually-hidden');
    zoomHint.textContent = T.zoom;
    stage.appendChild(img);
    box.appendChild(closeBtn);
    box.appendChild(stage);

    var thumbs = null;
    if (items.length > 1) {
      thumbs = el('div', 'mc2-lightbox__thumbs');
      items.forEach(function (item, i) {
        var b = el('button', 'mc2-lightbox__thumb', {
          type: 'button',
          'aria-label': T.thumb + ' ' + (i + 1),
          'data-index': String(i)
        });
        var t = el('img', '', { alt: item.alt, loading: 'lazy' });
        t.src = thumbUrl(item.full);
        b.appendChild(t);
        thumbs.appendChild(b);
      });
      box.appendChild(thumbs);
    }
    box.appendChild(zoomHint);
    overlay.appendChild(box);

    state = {
      overlay: overlay, box: box, stage: stage, img: img, thumbs: thumbs,
      items: items, index: -1, lastFocus: document.activeElement || trigger
    };

    // Events. All listeners live on elements inside the overlay (or are removed in
    // close()), so removing the overlay tears everything down.
    closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close(); // click outside the window
    });
    img.addEventListener('click', function () {
      var expanded = box.classList.toggle('mc2-lightbox--expanded');
      if (expanded) {
        stage.scrollLeft = Math.max(0, (stage.scrollWidth - stage.clientWidth) / 2);
        stage.scrollTop = Math.max(0, (stage.scrollHeight - stage.clientHeight) / 2);
      }
    });
    if (thumbs) {
      thumbs.addEventListener('click', function (e) {
        var b = e.target.closest('.mc2-lightbox__thumb');
        if (b) setActive(parseInt(b.getAttribute('data-index'), 10));
      });
    }
    document.addEventListener('keydown', onKeydown, true);

    document.documentElement.classList.add('mc2-lightbox-lock');
    document.body.appendChild(overlay);
    setActive(index);
    closeBtn.focus();
  }

  function setActive(i) {
    if (!state) return;
    if (i < 0 || i >= state.items.length) return;
    if (i === state.index) return;
    state.index = i;
    state.box.classList.remove('mc2-lightbox--expanded'); // new image starts fit-contain
    state.img.src = state.items[i].full;
    state.img.alt = state.items[i].alt;
    if (state.thumbs) {
      state.thumbs.querySelectorAll('.mc2-lightbox__thumb').forEach(function (b, j) {
        if (j === i) {
          b.setAttribute('aria-selected', 'true');
          b.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        } else {
          b.removeAttribute('aria-selected');
        }
      });
    }
  }

  function close() {
    if (!state) return;
    document.removeEventListener('keydown', onKeydown, true);
    document.documentElement.classList.remove('mc2-lightbox-lock');
    state.overlay.remove(); // full teardown: overlay, window, and all their listeners
    var back = state.lastFocus;
    state = null;
    if (back && typeof back.focus === 'function') back.focus();
  }

  function onKeydown(e) {
    if (!state) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'ArrowRight') { e.preventDefault(); setActive(Math.min(state.index + 1, state.items.length - 1)); return; }
    if (e.key === 'ArrowLeft') { e.preventDefault(); setActive(Math.max(state.index - 1, 0)); return; }
    if (e.key === 'Tab') {
      // keep focus inside the dialog
      var focusables = state.box.querySelectorAll('button, [href], img.mc2-lightbox__image');
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); } else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  // Delegated opener: PDP gallery images (grid on desktop, slideshow slides on mobile).
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var container = e.target.closest('media-gallery .product-media-container--image');
    if (!container) return;
    if (e.target.closest('a, button')) return; // let real controls (video, arrows) work
    var pm = container.querySelector('.product-media');
    var id = pm && pm.getAttribute('data-media-id');
    if (!id) return;
    var gallery = container.closest('media-gallery');
    e.preventDefault();
    open(gallery, id, container);
  });
})();
